import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/projected-ownership-force/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class PositionsBox extends Component {
    onChange(position, isChecked) {
        this.props.dispatch(Action.set('IgnoredPositionOfProjectedOwnershipForce', position, !isChecked));
    }

    render() {
        const {projectedOwnershipForce, sportConfig} = this.props;
        const positions = Object.values(sportConfig.getPositions());
        const minPositionsQuantityToAdjust = 2;

        if (positions.length < minPositionsQuantityToAdjust) {
            return null;
        }

        return (
            <>
                <div className="form-sub-text">of</div>
                {positions.map((position, index) => {
                    const isChecked = !projectedOwnershipForce.isPositionIgnored(position);
                    return (
                        <InputCheckbox
                            key={`position-${index}`}
                            label={position}
                            checked={isChecked}
                            onChange={(value) => ::this.onChange(position, value)}
                        />
                    );
                })}
            </>
        );
    }
}

function mapStatesToProps(state) {
    return {
        projectedOwnershipForce: state.projectedOwnershipForce,
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(PositionsBox);
